import { render, staticRenderFns } from "./LongTrendConfigWrapper.vue?vue&type=template&id=51c52872&"
import script from "./LongTrendConfigWrapper.vue?vue&type=script&lang=ts&"
export * from "./LongTrendConfigWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports